import styled from '@emotion/styled';

export const AgentPhoto = styled.div<{ imageURL?: string }>`
  width: 24px;
  height: 24px;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  margin: ${({ theme }) => `-${theme.spacing(0.25)} 0`};
  &:hover {
    & > div {
      display: initial;
    }
  }
  ${({ imageURL }) => imageURL ? `background-image: url(${imageURL});` : ''}
`;

export const AgentHoverPhoto = styled.div<{ imageURL?: string }>`
  width: 56px;
  height: 56px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  box-shadow: ${({ theme }) => theme.shadow.level7};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  ${({ imageURL }) => imageURL ? `background-image: url(${imageURL});` : ''}
  display: none;
  position: absolute;
  top: -60px;
  right: -15px;
  z-index: 3;
`;

export const OfficeLogosRoot = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  min-width: 56px;
`;
